<p class="modal-title">Are you sure?</p>
<div class="modal-close" (click)="wantToMoveForward(false)">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>
    If you continue without adding dependents your contribution limits will be changed to individual contribution limits.
</p>
<div class="button-container">
    <button class="button filled-green-button" (click)="wantToMoveForward(false)" (keyup.enter)="wantToMoveForward(false)" tabindex=0>ADD DEPENDENTS</button>
    <button class="button filled-gray-button" (click)="wantToMoveForward(true)" (keyup.enter)="wantToMoveForward(true)" tabindex=0>CHANGE TO INDIVIDUAL LIMITS</button>
</div>
